import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { fetchDate, fetchPostData } from '@/Components/hooks/Api';
import { threeColArray, threeColArrayWithCode } from '@/Components/Common/ChangeArrayFormat';

const IncidentContext = createContext();

export const IncidentProvider = ({ children }) => {
    const [incidentStatus, setIncidentStatus] = useState(false);
    const [showIncPage, setShowIncPage] = useState('home');
    const [incidentNumber, setIncidentNumber] = useState();
    const [crimeId, setCrimeId] = useState('');
    const [incStatus, setIncStatus] = useState();
    const [CaseStatus, setCaseStatus] = useState('Open');
    const [incidentReportedDate, setIncidentReportedDate] = useState(null);
    const [incidentRmsCfs, setIncidentRmsCfs] = useState('');
    const [incidentRecentData, setIncidentRecentData] = useState([]);
    const [incidentFilterData, setIncidentFilterData] = useState();
    const [AllProRoomFilterData, setAllProRoomFilterData] = useState();
    const [assignedReportID, setassignedReportID] = useState([]);
    const [reportedDtTmInc, setReportedDtTmInc] = useState();
    const [incAdvSearchData, setIncAdvSearchData] = useState(false);
    const [caseManagementDataIncidentRecent, setCaseManagementDataIncidentRecent] = useState([]);
    const [OfficerApprovCount, setOfficerApprovCount] = useState(false);
    const [isCadEditable, setIsCadEditable] = useState(false);

    const [offenceData, setOffenceData] = useState([]);
    const [offenceFillterData, setOffenceFillterData] = useState([]);
    const [exceptionalClearID, setEceptionalClearID] = useState([]);
    const [rmsDisposition, setRmsDisposition] = useState([]);

    const get_Offence_Data = (IncidentId) => {
        fetchPostData('Crime/GetData_Offense', { IncidentId }).then((res) => {
            setOffenceData(res || []);
            setOffenceFillterData(res || []);
        });
    };

    const GetDataExceptionalClearanceID = (LoginAgencyID) => {
        fetchPostData('Incident/GetData_ExceptionalClearance', { AgencyID: LoginAgencyID }).then((data) => {
            setEceptionalClearID(
                data ? threeColArrayWithCode(data, 'ClearanceID', 'Description', 'ClearanceCode') : []
            );
        });
    };

    const getRmsDispositionID = (LoginAgencyID) => {
        fetchPostData('Incident/GetData_RMSDisposition', { AgencyID: LoginAgencyID }).then((data) => {
            setRmsDisposition(
                data ? threeColArray(data, 'RMSDispositionId', 'RMSDispositionCode', 'DispositionCode') : []
            );
        });
    };

    const [incidentCount, setIncidentCount] = useState([]);
    const [tabCount, setTabCount] = useState([]);
    const [tabCountArrest, setTabCountArrest] = useState([]);

    const get_Incident_Count = (IncidentID, loginPinID) => {
        fetchPostData('HomeApi/GetData_IncidentCount', { IncidentID, PINID: loginPinID }).then((res) => {
            setIncidentCount(res || []);
        });
    };

    const get_IncidentTab_Count = (IncidentID, loginPinID) => {
        fetchPostData('HomeApi/GetData_IncidentTabCount', { IncidentID, PINID: loginPinID }).then((res) => {
            setTabCount(res?.[0] || []);
        });
    };

    const [datezone, setDatezone] = useState();
    const datezoneFetchRef = useRef({ agencyId: null, inFlight: false });

    const GetDataTimeZone = (AgencyID, force = false) => {
        if (!AgencyID) return;
        const agencyKey = String(AgencyID);
        const isSame = datezoneFetchRef.current.agencyId === agencyKey;
        if (!force && isSame && datezoneFetchRef.current.inFlight) return;
        if (!force && isSame && datezone) return;

        datezoneFetchRef.current = { agencyId: agencyKey, inFlight: true };
        fetchDate('Account/GetDateTime', { AgencyID })
            .then((res) => {
                if (res) setDatezone(res);
            })
            .finally(() => {
                datezoneFetchRef.current = { agencyId: agencyKey, inFlight: false };
            });
    };

    const [eventData, setEventData] = useState([]);
    const [resourceData, setResourceData] = useState([]);
    const [allResourcesData, setAllResourcesData] = useState([]);

    const [nibrsStatus, setnibrsStatus] = useState(false);
    const [nibrsSubmittedStatus, setnibrsSubmittedStatus] = useState(0);
    const [nibrsSubmittedAdministartive, setnibrsSubmittedAdministartive] = useState(1);
    const [nibrsSubmittedOffense, setnibrsSubmittedOffense] = useState(0);
    const [nibrsSubmittedOffender, setnibrsSubmittedOffender] = useState(0);
    const [nibrsSubmittedVictim, setnibrsSubmittedVictim] = useState(0);
    const [nibrsSubmittedProperty, setnibrsSubmittedProperty] = useState(0);
    const [nibrsSubmittedVehicle, setnibrsSubmittedVehicle] = useState(0);
    const [nibrsSubmittedArrestee, setnibrsSubmittedArrestee] = useState(0);
    const [nibrsSubmittedName, setnibrsSubmittedName] = useState(0);
    const [nibrsSubmittedIncident, setnibrsSubmittedIncident] = useState(0);
    const [nibrsSubmittedOffenseMain, setnibrsSubmittedOffenseMain] = useState(0);
    const [nibrsSubmittedPropertyMain, setnibrsSubmittedPropertyMain] = useState(0);
    const [nibrsSubmittedvehicleMain, setnibrsSubmittedvehicleMain] = useState(0);
    const [nibrsSubmittedArrestMain, setnibrsSubmittedArrestMain] = useState(0);

    const [isRestricted, setIsRestricted] = useState(false);
    const [permissionToUnrestrict, setPermissionToUnrestrict] = useState(false);

    const getPermissionLevelByRestrict = useCallback(async (IncidentID, OfficerID) => {
        try {
            const res = await fetchPostData("Restricted/GetPermissionLevelBy_Restricted", { 
                IncidentID: parseInt(IncidentID), 
                OfficerID: parseInt(OfficerID), 
                'ModuleName': "Incident", 
                'ID': 0 
            });
            if (res?.length > 0) {
                setIsRestricted(res[0]?.IsRestricted === true || res[0]?.IsRestricted === 1 ? true : false);
                setPermissionToUnrestrict(res[0]?.IsUnRestrictPermission === true || res[0]?.IsUnRestrictPermission === 1 ? true : false);
            } else {
                setPermissionToUnrestrict(false);
                setIsRestricted(false);
            }
        } catch {
            setPermissionToUnrestrict(false);
            setIsRestricted(false);
        }
    }, []);

    return (
        <IncidentContext.Provider value={{
            incidentStatus, setIncidentStatus,
            showIncPage, setShowIncPage,
            incidentNumber, setIncidentNumber,
            crimeId, setCrimeId,
            incStatus, setIncStatus,
            CaseStatus, setCaseStatus,
            incidentReportedDate, setIncidentReportedDate,
            incidentRmsCfs, setIncidentRmsCfs,
            incidentRecentData, setIncidentRecentData,
            incidentFilterData, setIncidentFilterData,
            AllProRoomFilterData, setAllProRoomFilterData,
            assignedReportID, setassignedReportID,
            reportedDtTmInc, setReportedDtTmInc,
            incAdvSearchData, setIncAdvSearchData,
            caseManagementDataIncidentRecent, setCaseManagementDataIncidentRecent,
            OfficerApprovCount, setOfficerApprovCount,
            isCadEditable, setIsCadEditable,

            offenceData, offenceFillterData, setOffenceFillterData,
            get_Offence_Data,
            exceptionalClearID, setEceptionalClearID, GetDataExceptionalClearanceID,
            rmsDisposition, setRmsDisposition, getRmsDispositionID,

            incidentCount, setIncidentCount, get_Incident_Count,
            tabCount, setTabCount, get_IncidentTab_Count,
            tabCountArrest, setTabCountArrest,

            datezone, setDatezone, GetDataTimeZone,
            eventData, setEventData,
            resourceData, setResourceData,
            allResourcesData, setAllResourcesData,

            nibrsStatus, setnibrsStatus,
            nibrsSubmittedStatus, setnibrsSubmittedStatus,
            nibrsSubmittedAdministartive, setnibrsSubmittedAdministartive,
            nibrsSubmittedOffense, setnibrsSubmittedOffense,
            nibrsSubmittedOffender, setnibrsSubmittedOffender,
            nibrsSubmittedVictim, setnibrsSubmittedVictim,
            nibrsSubmittedProperty, setnibrsSubmittedProperty,
            nibrsSubmittedVehicle, setnibrsSubmittedVehicle,
            nibrsSubmittedArrestee, setnibrsSubmittedArrestee,
            nibrsSubmittedName, setnibrsSubmittedName,
            nibrsSubmittedIncident, setnibrsSubmittedIncident,
            nibrsSubmittedOffenseMain, setnibrsSubmittedOffenseMain,
            nibrsSubmittedPropertyMain, setnibrsSubmittedPropertyMain,
            nibrsSubmittedvehicleMain, setnibrsSubmittedvehicleMain,
            nibrsSubmittedArrestMain, setnibrsSubmittedArrestMain,

            isRestricted, setIsRestricted,
            permissionToUnrestrict,
            setPermissionToUnrestrict,
            getPermissionLevelByRestrict
        }}>
            {children}
        </IncidentContext.Provider>
    );
};

export const useIncident = () => {
    const context = useContext(IncidentContext);
    if (!context) {
        throw new Error('useIncident must be used within an IncidentProvider');
    }
    return context;
};

export default IncidentContext;
